module.exports = __webpack_public_path__ + "asset/image-ic_category_16-33ce554a1b48ff6f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/ic_category_16.svg
// module id = /sYY
// module chunks = 0